/**
 * Created by Ning Jiang on 6/29/2018.
 */

export class FruitsReelSymbolName {

    public static readonly B1:string = "B1";
    public static readonly B2:string = "B2";
    public static readonly X:string = "X";
}